// extracted by css-extract-rspack-plugin
var _1 = "CgwzVYWIJbYnrVgu";
var _2 = "dsCyNCnettglC_hF";
export { _1 as "centerBox", _2 as "centerBoxContent" }
